import React from 'react';
import { MdKeyboardArrowRight } from 'react-icons/md';
import TextTruncate from '../TextTruncate';
import { getSubscriptionData } from '../../utils/sharedData';
import { useDisplayWidgetContext } from '../DisplayWidget/utils/context';
import { addUTMToURL, calculatePrice, getCurrentSymbol } from '../../Helpers/Helpers';
export default function TagProductBox({ data }) {
  const amountFormatter = new Intl.NumberFormat();
  const currency = getSubscriptionData()?.data?.currency;

  const { data: widgetData, shopifyData, layout } = useDisplayWidgetContext();

  return (
    <idk-div
      class="zid-p-2 zid-m-0 zid-flex zid-flex-col zid-gap-2 zid-drop-shadow zid-rounded zid-items-center zid-justify-between	"
      style={{ maxWidth: '150px', cursor: 'pointer', backgroundColor: '#fff', minWidth: '150px' }}
    >
      {data?.image || data?.images ? (
        <img
          loading="lazy"
          src={(() => {
            const raw = data?.images?.[0]?.image_url || data?.images?.[0] || data?.image || '';
            const first = raw.split(',')[0].trim();
            return first.includes('cdn.shopify.com')
              ? first + (first.includes('?') ? '&width=135' : '?width=135')
              : first;
          })()}
          className="zid-rounded"
          width="100%"
          style={{ maxWidth: '150px', height: 'auto' }}
        />
      ) : null}

      <idk-div class="zid-h-full">
        <TextTruncate style={{ WebkitLineClamp: 2, textAlign: 'start', color: '#141414', fontSize: '14px' }}>
          <b>{data?.title}</b>
        </TextTruncate>
        {data?.variants && (
          <idk-p class="zid-mt-1 zid-p-0" style={{ fontWeight: 600, fontSize: '22px' }}>
            {(widgetData.result.currency &&
              getCurrentSymbol(widgetData.result.currency, navigator?.language || navigator['userLanguage'])) ||
              currency}
            {shopifyData
              ? calculatePrice(
                  parseFloat(data?.variants[0]?.price ? data?.variants[0]?.price : '') / 100,
                  parseFloat(shopifyData?.currency?.rate),
                )
              : amountFormatter.format(data?.variants[0]?.price ? data?.variants[0]?.price : '')}
          </idk-p>
        )}
        <idk-p
          class="zid-flex zid-items-center zid-underline zid-w-full"
          onClick={() => {
            window.open(
              addUTMToURL(data?.product_url ? data?.product_url : window.location.origin + data?.url, {
                utm_source: layout?.gallerySettings?.utmSource,
                utm_medium: layout?.gallerySettings?.utmMedium,
                utm_campaign: layout?.gallerySettings?.utmCampaign,
              }),
              '_blank',
            );
          }}
        >
          View Product
          <MdKeyboardArrowRight size={22} />
        </idk-p>
      </idk-div>
    </idk-div>
  );

  return (
    <idk-div
      class="zid-p-2 zid-m-0 zid-flex zid-gap-2 zid-drop-shadow zid-rounded zid-items-center zid-justify-between	"
      style={{ maxWidth: '200px', cursor: 'pointer', backgroundColor: '#fff', minWidth: '200px' }}
      onClick={() => {
        window.open(data?.product_url, '_blank');
      }}
    >
      {data?.images && (
        <img
          loading="lazy"
          src={data?.images[0]?.image_url}
          className="zid-rounded"
          width="100%"
          style={{ maxWidth: '40px', height: 'auto' }}
        />
      )}
      <idk-div class="zid-h-full">
        <TextTruncate style={{ WebkitLineClamp: 2, textAlign: 'start', color: '#141414', fontSize: '14px' }}>
          <b>{data?.title}</b>
        </TextTruncate>
        {data?.variants && (
          <idk-p class="zid-mt-1 zid-p-0" style={{ fontWeight: 500, fontSize: '12px' }}>
            {(widgetData.result.currency &&
              getCurrentSymbol(widgetData.result.currency, navigator?.language || navigator['userLanguage'])) ||
              currency}
            {amountFormatter.format(data?.variants[0]?.price ? data?.variants[0]?.price : '')}
          </idk-p>
        )}
      </idk-div>
      <MdKeyboardArrowRight size={40} />
    </idk-div>
  );
}
